import { render, staticRenderFns } from "./CellImageRender.vue?vue&type=template&id=2048bc2b&"
import script from "./CellImageRender.vue?vue&type=script&lang=js&"
export * from "./CellImageRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports